import { defineComponent } from 'vue';
import omoList from '@/components/list/omoListItem.vue';
import ListWrapper from './listWrapper.vue';
import { getMeetingList } from '@/api/meeting';
import { getUserId } from '@/widget/index';
export default defineComponent({
    props: {
        size: {
            default: '',
            type: String
        },
        moduleId: {
            type: Number
        },
        subDepId: {
            type: Number
        },
        diseaseId: {
            type: Number
        },
        flagBl: {
            type: Boolean,
            default: false
        },
        labelId: {
            default: 0
        },
        labelType: {
            default: 'root'
        }
    },
    watch: {
        flagBl(newData) {
            if (newData) {
                this.pageNo = 1;
                this.getList();
            }
        }
    },
    data() {
        return {
            list: [],
            pageNo: 1,
            pageCount: 1,
            flag: true
        };
    },
    methods: {
        getList() {
            getMeetingList({
                params: {
                    userId: getUserId()
                },
                query: {
                    isOperation: 2,
                    pageSize: 10,
                    pageNo: this.pageNo,
                    labelId: this.labelId,
                    labelType: this.labelType
                }
            }).then(res => {
                this.flag = true;
                this.$hideLoading();
                if (res.code === 200) {
                    if (this.pageNo === 1) {
                        this.list = res.data.list;
                        this.$emit('initFlag');
                    }
                    else {
                        this.list = this.list.concat(res.data.list);
                    }
                    this.pageCount = res.data.pageCount;
                }
                else {
                    this.$toast(res.message);
                }
            });
        },
        initData() {
            this.pageNo = 1;
            this.pageCount = 1;
            this.list = [];
        },
        showMore() {
            if (this.flag) {
                this.pageNo = this.pageNo + 1;
                this.flag = false;
                this.$showLoading();
                this.getList();
            }
            else {
                this.$toast('数据加载中，请稍后');
            }
        }
    },
    components: {
        ListWrapper,
        omoList
    }
});
